import { SpecialOfferProps } from '../types';
import { Box } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { BabaSaleBadge } from 'components/Badge/Sale/BabaSaleBadge';
import { BabaBundlePrice } from 'templates/Bundles/Baba/BundlePrice';
import { BabaMainProduct } from 'templates/Bundles/Baba/BundleProduct/main';
import { EProductPriority, ESaleDiscountDisplayType } from 'utils/enums';
import { ProductData } from 'utils/types';
import { StyledBabaSpecialOffer, StyledPriceSection } from './style';
import { babaUtils } from 'templates/Bundles/Baba/utils';
import { BabaTimerBadge } from './TimerBadge';
import { BabaSubProduct } from 'templates/Bundles/Baba/BundleProduct/sub';
import { StyledSubProductsContainer } from 'templates/Bundles/Baba/style';

export const BabaSpecialOffer: React.FC<SpecialOfferProps> = ({
  prices,
  dataTestId,
  backgroundImage = 'https://media-staging.appcharge.com/media/66f2b3c0fea2a56ff9086cdb/1728567434486__c64437ff-0754-45ee-b6a8-b83103ad188d',
  backgroundColor = { colorOne: '#8106a1' },
  productsList,
  salePercentage = 0,
  salePercentageDisplayType = ESaleDiscountDisplayType.PERCENTAGE,
  buttonTextColor,
  buttonColor,
  inMobileMock = false,
  selectOffer,
  availability,
  availabilityText = 'Available',
  isFree = false,
  collectText = 'Collect',
  timer,
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData | null>(null);
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);

  useEffect(() => {
    if (!productsList || productsList.length === 0) return;

    const main = productsList.find(
      (product) => product.priority === EProductPriority.MAIN,
    );

    setMainProduct(productsList[0]);

    setSubProducts(productsList.slice(1));
  }, [productsList]);

  const availabilityDisplayText = useMemo(
    () =>
      availability
        ? `${availabilityText} ${availability.remaining}/${availability.total}`
        : '',
    [availability],
  );

  return (
    <StyledBabaSpecialOffer
      backgroundSrc={backgroundImage}
      backgroundColor={backgroundColor}
      className={
        'baba-promotion' + (inMobileMock ? ' bundle--iphone-mock' : '')
      }
      onClick={selectOffer}
      data-testid={dataTestId}
    >
      <Box className="container" gap="8px">
        {salePercentage > 0 && (
          <BabaSaleBadge
            salePercentage={salePercentage}
            salePercentageDisplayType={salePercentageDisplayType}
            isPromotion
          />
        )}
        {productsList.length > 0 ? (
          <Box className="products">
            <BabaMainProduct
              quantityDisplay={mainProduct?.quantityDisplay}
              strokedSaleQuantity={mainProduct?.strokedSaleQuantity}
              image={mainProduct?.images?.product}
              salePercentage={salePercentage}
            />
            <StyledSubProductsContainer>
              {subProducts.map((product, i, sbArray) => (
                <BabaSubProduct
                  key={i}
                  textFontColorHex={product.textFontColorHex}
                  quantityDisplay={product.quantityDisplay}
                  images={product.images}
                  isLastInRow={babaUtils.getIsLastInRow(i, sbArray)}
                />
              ))}
            </StyledSubProductsContainer>
          </Box>
        ) : (
          <Box className="products" />
        )}
        <StyledPriceSection>
          <BabaTimerBadge timer={timer} />
          <BabaBundlePrice
            prices={prices}
            bundleButtonColor={buttonColor}
            bundleButtonTextColor={buttonTextColor}
            isFree={isFree}
            collectText={collectText}
          />
          <div className={'availability-label'}>
            {availabilityDisplayText ? availabilityDisplayText : ''}
          </div>
        </StyledPriceSection>
      </Box>
    </StyledBabaSpecialOffer>
  );
};
